import { render, staticRenderFns } from "./CompanyBroadcastMessage.vue?vue&type=template&id=0d687020"
import script from "./CompanyBroadcastMessage.vue?vue&type=script&lang=js"
export * from "./CompanyBroadcastMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports